export const viewData = [
  { type: "ping4", name: "Ping4" },
  { type: "ping6", name: "Ping6" },
  { type: "traceroute4", name: "TraceRoute4" },
  { type: "traceroute6", name: "TraceRoute6" },
  { type: "netscan", name: "NetScan" },
  { type: "wiremap", name: "WireMap" },
  { type: "poeload", name: "PoeLoad" },
  { type: "maxthroughput", name: "Maxthroughput" },
  { type: "uptime", name: "Uptime" },
  { type: "customdata", name: "CustomData" },
  { type: "cabledata", name: "CableData" },
  { type: "webdata", name: "WebData" },
  { type: "voipdata", name: "VoIPData" },
  { type: "videodata", name: "VideoData" },
  { type: "cctvdata", name: "CCTVData" },
  { type: "fiberlengthloss", name: "FiberLengthLoss" },
  { type: "qualification", name: "Qualification" },
  { type: "stats", name: "Stats" },
  { type: "qualification_il", name: "qualification_il" },
  { type: "qualification_rl", name: "qualification_rl" },
  { type: "qualification_next", name: "qualification_next" },
];
